import { useResetQueryMutation } from 'query';
import { Loading } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useCommunitiesQuery } from 'features/communities/queries';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useProfileQuery } from 'features/users/queries';
import { ConsentsForm } from '../components';
import { useConsentsQuery } from '../queries';

type P = {
  onAccept: () => Promise<void>;
  onReject: () => Promise<void>;
};

const Consents = ({ onAccept, onReject }: P) => {
  const { mutateAsync: resetQuery } = useResetQueryMutation();
  const {
    data: profileData,
    isFetching: isFetchingProfile,
    isLoading: isLoadingProfile,
  } = useProfileQuery({ gcTime: 0, staleTime: 0 });
  const {
    data: consents,
    isFetching: isFetchingConsents,
    isLoading: isLoadingConsents,
  } = useConsentsQuery({ consentIds: profileData?.requiredConsents.map((consent) => consent.id) });

  const {
    data: communitiesThatRequiresConsents,
    isFetching: isFetchingCommunities,
    isLoading: isLoadingCommunities,
  } = useCommunitiesQuery({
    scope: 'non_consented',
  });

  if (
    (isLoadingProfile && isFetchingProfile) ||
    !profileData ||
    (isLoadingConsents && isFetchingConsents) ||
    !consents ||
    (isLoadingCommunities && isFetchingCommunities) ||
    !communitiesThatRequiresConsents
  ) {
    return <Loading />;
  }

  const handleAccept = async () => {
    await resetQuery({ cacheResetOption: 'reset' });
    await onAccept();
  };

  const handleReject = async () => {
    await resetQuery({ cacheResetOption: 'reset' });
    await onReject();
  };

  return (
    <ConsentsForm
      consents={consents}
      currentAcceptedConsents={profileData.usersConsents}
      entities={communitiesThatRequiresConsents.data}
      onAccept={handleAccept}
      onReject={handleReject}
    />
  );
};

export default Consents;
